var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActionCheckbox',{attrs:{"checked":_vm.omitYear},on:{"check":_vm.removeYear,"uncheck":_vm.addYear}},[_vm._v("\n\t"+_vm._s(_vm.t('contacts', 'Omit year'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }